<template>
    <v-layout row justify-center data-testid="popup">
        <v-dialog v-model="dialog" scrollable max-width="1024px">
            <v-card class="popup-text ql-editor" style="min-height: 100px;">
                <h1 aria-hidden="false" tabindex="0" :aria-label="$t('base.popup.titleAriaLabel')">
                    {{ $t('base.popup.title') }}
                </h1>
                <span aria-hidden="false" tabindex="0" v-html="text" />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        aria-hidden="false"
                        tabindex="0"
                        :aria-label="$t('base.closeAriaLabel')"
                        color="button-secondary-color"
                        rounded
                        @click="closePopUp">
                        {{ $t('base.close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
export default {
    props: {
        text: { type: String, required: true },
        dialog: { type: Boolean, required: true }
    },
    methods: {
        closePopUp() {
            this.$emit('closePopUp');
        },
    },
};
</script>
